import { lazy } from 'react';
var INQ00001 = lazy(function () { return import('view/Project/INQ/INQ00001/INQ00001_home'); });
var INQ00002 = lazy(function () { return import('view/Project/INQ/INQ00002/INQ00002_home'); });
var INQ00003 = lazy(function () { return import('view/Project/INQ/INQ00003/INQ00003_home'); });
var INQ00004 = lazy(function () { return import('view/Project/INQ/INQ00004/index'); });
var INQ_ROUTES = [
    { path: '/INQ00/INQ00001', component: INQ00001 },
    { path: '/INQ00/INQ00002', component: INQ00002 },
    { path: '/INQ00/INQ00003', component: INQ00003 },
    { path: '/INQ00/INQ00004', component: INQ00004 },
];
export default INQ_ROUTES;
